import APIClient from './index';

export const fetchOAuthApplications = () => APIClient.get('OAuthApplications/admin/list').then(r => r.data);

export const createOAuthApplication = payload => APIClient.post('OAuthApplications/admin/create', payload).then(r => r.data);

export const updateOAuthApplication = payload => APIClient.post('OAuthApplications/admin/update', payload).then(r => r.data);
